<template>
  <RichMarker :position="marker.position">
    <div class="pulse_marker"></div>
  </RichMarker>

</template>

<script>
import RichMarker from './RichMarker';

export default {
  props: {
    marker: {
      required: true
    }
  },
  components: {
    RichMarker
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Marker.vue